/**
 * 首页
*/
import http from '@/request/http'
export default {
  // 建筑信息
  getBuildinginfo: params => http.get(`/api/juji/main/buildinginfo`, params),
  // 指标数据
  homeGetIndexData: params => http.get(`/api/plugins/statistics/getTargetData`, params),
  // 系统指标
  homeSystemIndex: params => http.get(`/api/juji/main/getSystemTargets`, params),
  // 获取轮播图
  homeGetCarouselImg: params => http.get(`/api/juji/main/getRotatePictures`, params),
  // 获取室内环境指标
  homeIndoorEnvironment: params => http.get(`/api/juji/main/getIndoorEnvironmentTargets`, params),
  // 获取室内资产列表
  homeIndoorAssetsList: params => http.get(`/api/juji/subSystemIndoorEnvironment/showAssets`, params),
  // 获取项目能源类型
  getEnergyTypeByProjectId: params => http.get(`/api/juji/additionalEnergyDevice/getEnergyType`, params),


  

}

